/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { FileboyPdfRenderer } from "./SaaSTermsPage"

export function IndividualUserTermsPage() {
  return (
    <div
      css={css`
        padding: 16px 16px;
        overflow: auto;
      `}
    >
      <FileboyPdfRenderer
        fileboyId={"ceb56212-56be-4c84-820e-184261dbc88f"}
        name="CleverGoose Individual User Terms"
      />
    </div>
  )
}
